import { defaultState } from './defaultState'
import { notificationsTypes } from '../../actions/notifications/notificationsTypes'

export default (state = defaultState, { type, payload }) => {

  switch (type) {

    case notificationsTypes.ADD_NOTIFICATION :
      return { ...state, list: [...state.list, payload] }
    case notificationsTypes.REMOVE_NOTIFICATION :
      return { ...state, list: state.list.filter(({ id }) => payload !== id) }
    default: {

      return state

    }

  }

}
